module.exports = __webpack_public_path__ + "static/media/settings-cog.6316fe7b.svg";